import React from "react";
import { Edit, Trash2 } from "lucide-react";

const DepartmentTable = ({
  displayedData,
  handleEditDepartment,
  handleDeleteDepartment,
}) => {
  return (
    <div className="bg-white rounded-lg shadow overflow-hidden">
      <div className="overflow-x-auto min-w-0">
        <table className="w-full min-w-max">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                S.No
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Name
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Description
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {displayedData.map((item, index) => (
              <tr key={item.departmentId || index} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {index + 1}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {item.name}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {item.description}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  <div className="flex space-x-2">
                    {item.name?.toLowerCase() === "maintenance" ? (
                      <span className="text-xs text-gray-500 italic">Protected</span>
                    ) : (
                      <>
                        <button
                          onClick={() => handleEditDepartment(item.departmentId)}
                          className="inline-flex items-center justify-center w-8 h-8 bg-blue-100 text-blue-600 rounded hover:bg-blue-200 hover:scale-110 transition-all duration-200 shadow-sm"
                        >
                          <Edit size={16} />
                        </button>
                        <button
                          onClick={() => {
                            if (item.name?.toLowerCase() === "maintenance") {
                              return; // Prevent deletion of maintenance department
                            }
                            handleDeleteDepartment(item.departmentId);
                          }}
                          className="inline-flex items-center justify-center w-8 h-8 bg-red-100 text-red-600 rounded hover:bg-red-200 hover:scale-110 transition-all duration-200 shadow-sm"
                        >
                          <Trash2 size={16} />
                        </button>
                      </>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DepartmentTable;
